"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorDialog = void 0;
var _react = _interopRequireDefault(require("react"));
var _dialog = require("../../../../../dist/components/domainless/overlay/dialog");
var _SNETButton = _interopRequireDefault(require("../../data-entry/SNETButton"));
var _ErrorDialogModule = _interopRequireDefault(require("./ErrorDialog.module.css"));
var _AlertBox = _interopRequireDefault(require("../../feedback/AlertBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ErrorDialog = _ref => {
  let {
    error,
    errors,
    isDialogOpen,
    onClose,
    ...rest
  } = _ref;
  if (error && errors) {
    console.warn("[ErrorDialog] Don't use error and errors props at the same time");
  }
  if (errors && !Array.isArray(errors)) {
    throw new TypeError("[ErrorDialog] Expected Array for errors prop");
  }
  return /*#__PURE__*/_react.default.createElement(_dialog.SNETDialog, {
    title: rest.title ?? "Error!",
    maxWidth: false,
    isDialogOpen: isDialogOpen,
    onDialogClose: onClose,
    disableBackdropClick: false,
    disableEscapeKeyDown: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ErrorDialogModule.default["dialog-body"]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ErrorDialogModule.default["errors-holder"]
  }, error && /*#__PURE__*/_react.default.createElement(_AlertBox.default, null, error.message || error.toString()), errors && errors.map((error, index) => /*#__PURE__*/_react.default.createElement(_AlertBox.default, {
    key: index
  }, error.message || error.toString()))), /*#__PURE__*/_react.default.createElement(_SNETButton.default, {
    variant: "contained",
    color: "primary",
    onClick: onClose
  }, "Close")));
};
exports.ErrorDialog = ErrorDialog;